<template>
  <div :class="['select', this.className, `size-${size}`]">
    <span v-if="title">{{ title }}</span>
    <el-select
      :disabled='disabled'
      v-model="selected"
      :remote="remote"
      :placeholder="placeholder"
      :size="size"
    >
      <el-option
        style="font-family: 'Inter-Regular', sans-serif;"
        v-for="option in options"
        :key="option.value || option"
        :label="option.title || option"
        :value="option.value || option"
        :class="{ 'disabled': option.disabled}"
      />
    </el-select>
  </div>
</template>

<script>
export default {
  name: 'Select',
  props: {
    value: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      default: () => '',
    },
    placeholder: {
      type: String,
      default: () => '',
    },
    remote: {
      type: Boolean,
      default: () => true,
    },
    className: {
      type: String,
      default: () => '',
    },
    size: {
      type: String,
      default: () => '',
    },
    disabled: {
      required: false,
      default: false,
      type: Boolean,
    },
  },
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(value) {
        if (!this.disabled) {
          this.$emit('input', value);
        }
      },
    },
  },

};
</script>

<style lang="scss">
.el-scrollbar__wrap {
  margin-bottom: -17px !important;
}
</style>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.disabled {
  color: var(--text-disabled);
}
</style>
